module.exports = __webpack_public_path__ + "minigame-1c481c70ee9f7c75b0c3fd21527a9d1b.svg";